module.exports = __webpack_public_path__ + "img/icon_hotels.8533a9b5.png";